import React, { useContext } from 'react';

import { ProjectsContext } from '../../../../../views/dashboard/lender/investment/projects/ProjectsContext';
import { CrossIcon } from '../../../../common';
import { defaultProjectsFilter } from '../ProjectsFilter/utils';

import './ProjectsFilterClearAll.scoped.scss';

const ProjectsFilterClearAll = () => {
  const { filter, setFilter, toggleFilter } = useContext(ProjectsContext);
  const clearFilter = () => {
    setFilter({ ...defaultProjectsFilter, statuses: filter.statuses });
    toggleFilter();
  };
  return (
    <div onClick={clearFilter} className="projects-filter-clear-all">
      <CrossIcon preset="default" size={16} title="Сбросить весь фильтр" />
      <div>Сбросить весь фильтр</div>
    </div>
  );
};

export default ProjectsFilterClearAll;
